// extracted by mini-css-extract-plugin
export default {"page":"OrgMapping_page__3ZBTr"};